export enum UserFeedbackStatus {
  Succeeded = 'succeeded',
  Failed = 'failed',
  Processing = 'processing',
  Completed = 'completed',
}
